module.exports = __webpack_public_path__ + "src/assets/img/bath-bessom.d8a78f0b.svg";